import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { adminApi } from "../adminApi";

const FIELDS = [
  { section: "Homepage — Hero", items: [
    { key: "home_hero_line1", label: "Headline Line 1" },
    { key: "home_hero_line2", label: "Headline Line 2" },
    { key: "home_hero_line3", label: "Headline Line 3" },
    { key: "home_hero_subheading", label: "Sub-heading", area: true },
    { key: "home_positioning", label: "Positioning Statement", area: true },
  ]},
  { section: "About Page", items: [
    { key: "about_mission", label: "Mission", area: true },
    { key: "about_vision", label: "Vision", area: true },
  ]},
  { section: "Services / Capabilities", items: [
    { key: "services_intro", label: "Capabilities Intro", area: true },
  ]},
];

const FIELD = "w-full rounded-lg border border-[#E5E7EB] px-4 py-2.5 text-sm text-[#1F2937] focus:outline-none focus:border-[#1E88E5] focus:ring-2 focus:ring-[#1E88E5]/20 transition";

export default function AdminContent() {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminApi.get("/admin/content").then(({ data }) => setContent(data));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await adminApi.put("/admin/content", content);
      toast.success("Content saved — changes are live on the website.");
    } catch {
      toast.error("Failed to save content.");
    } finally {
      setSaving(false);
    }
  };

  if (!content) return <div className="flex items-center gap-2 text-[#4B5563]"><Loader2 className="animate-spin" size={18} /> Loading…</div>;

  return (
    <div className="space-y-6 max-w-3xl" data-testid="admin-content">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#0A2342]">Website Content</h1>
        <p className="text-sm text-[#4B5563] mt-1">Edit key text shown on the public website. Changes apply immediately.</p>
      </div>

      {FIELDS.map((group) => (
        <div key={group.section} className="bg-white rounded-xl border border-[#E5E7EB] p-6">
          <h3 className="font-heading font-semibold text-[#0A2342] mb-4">{group.section}</h3>
          <div className="space-y-4">
            {group.items.map((f) => (
              <div key={f.key}>
                <label className="block text-sm font-semibold text-[#0A2342] mb-1.5">{f.label}</label>
                {f.area ? (
                  <textarea data-testid={`content-${f.key}`} rows={3} className={FIELD} value={content[f.key] || ""} onChange={(e) => setContent((c) => ({ ...c, [f.key]: e.target.value }))} />
                ) : (
                  <input data-testid={`content-${f.key}`} className={FIELD} value={content[f.key] || ""} onChange={(e) => setContent((c) => ({ ...c, [f.key]: e.target.value }))} />
                )}
              </div>
            ))}
          </div>
        </div>
      ))}

      <button data-testid="content-save" onClick={save} disabled={saving} className="inline-flex items-center gap-2 rounded-lg bg-[#0A2342] text-white px-6 py-3 font-semibold hover:bg-[#1E88E5] transition-colors disabled:opacity-60">
        {saving ? <Loader2 size={18} className="animate-spin" /> : <Save size={18} />} Save Changes
      </button>
    </div>
  );
}
